<template>
  <div class="send_mfa_area max-width-800 padding-top padding-bottom">
    <template v-if="!setup_mfa">
      <div class="row">
        <div class="col">
          <h1>Set up Multi-Factor Authentication?</h1>
          <p>
            Multi-factor authentication is important for improving account
            security. You will be asked to provide a code when logging in once
            this is set up.
          </p>
        </div>
        <div class="col text-center">
          <img
            style="max-width: none"
            class="img-responsive"
            src="\images\mfa-security-icon.png"
            title="MFA Security Image"
          />
        </div>
      </div>

      <div class="row py-5">
        <div class="col text-center">
          <button
            type="button"
            class="btn button-green width-100"
            v-on:click="setupMFA()"
          >
            Set Up
          </button>
        </div>
        <div class="col text-center">
          <button
            type="button"
            class="btn button-grey width-100"
            v-on:click="redirectUser()"
          >
            Skip for now
          </button>
        </div>
      </div>
    </template>
    <template v-else>
      <UpdateMFAComponent :mfa_info="mfa_info" @close="verifyMFA()" />
    </template>
  </div>
</template>

<script>
  import UpdateMFAComponent from '~/components/user/mfa/UpdateMFAComponent.vue';
  export default {
    name: 'SetupMFAComponent',
    components: {
      UpdateMFAComponent,
    },  
    props: {
      mfa_info: {
        type: Object,
        default() {
          return {
            email: '',
            phone: '',
          };
        },
      }, // user mfa object
      components: {
        UpdateMFAComponent,
      },
      user: {
        type: Object,
        default() {
          return null;
        },
      },
    },

    data: function () {
      return {
        setup_mfa: false,
      };
    },

    mounted() {
      this.setDefaults();
    },

    methods: {
      setDefaults() {
        if (!this.mfa_info.email && !this.mfa_info.phone) {
          this.mfa_info.email = this.user.email;
          this.mfa_info.phone = this.user.phone;
        }
      },
      setupMFA: function () {
        this.setup_mfa = true;
      },
      verifyMFA: function () {
        // this.setup_mfa = false;
        this.redirectUser();
      },
      redirectUser: function () {
        // get redirect url - if found - default is home page
        let redirect =
          new URL(location.href).searchParams.get('redirect') ?? '';

        if (redirect.startsWith('/')) {
          redirect = redirect.substring(1);
        }
        // redirect user to area they were going
        window.location =
          location.protocol + '//' + location.hostname + '/' + redirect;
      },
    },
  };
</script>
